import React, { useState } from "react";
import "../CSS/TabsPage.css";

import Complaints from '../Pages/Complaints.js';
import USDA from '../Pages/USDA.js';
import AALAC from '../Pages/AALAC.js';
import USDAAction from '../Pages/USDAActionReports.js'

import EmailFormModal from '../Components/ARModal.js';

const TabsPage = () => {
  const [activeTab, setActiveTab] = useState("complaints");
  const [showModal, setShowModal] = useState(false);
  const [powerBiModal, setPowerBiModal] = useState(null);

  const closePowerBiModal = () => {
    setPowerBiModal(null);
  };

  return (
    <div className="tabs-page">
      <div className="reports-hero riskhub-hero">
        <div className="reports-hero-content">
          <p className="reports-eyebrow">Orion Intelligence Platform</p>

          <h1>AR Risk Intelligence Hub</h1>

          <p className="reports-hero-description">
            Resource to observe current AR-related intelligence related to targeted
            entities and business operational risk — with specific attention and
            data toward activist-related targeting and reputational exposure all
            in one interface.
          </p>

          <p className="reports-hero-description">
            We can help organizations verify the reliability and integrity of
            partners, vendors, and facilities.
          </p>

          <p className="reports-hero-description">
            Our online services include the following available information for searching.
          </p>

          <p className="reports-hero-description">

          For a full in-depth company due diligence report, to include financial information/UCCs,

          past or current lawsuits, overall media sentiments, and a full activism assessment – please

          request

          <span

            className="open-modal-link"

            onClick={() => setShowModal(true)}

            style={{

              cursor: "pointer",

              color: "#cab069",

              textDecoration: "underline",

              marginLeft: "4px"

            }}

          >

            here

          </span>.

        </p>



          <div className="tabs-header hero-tabs-header">
            <button
              className={activeTab === "complaints" ? "tab active" : "tab"}
              onClick={() => setActiveTab("complaints")}
            >
              Activist Complaints
            </button>

            <button
              className="tab"
              onClick={() => setPowerBiModal("USDA")}
            >
              USDA Inspection Tracking
            </button>

             <button
              className="tab"
              onClick={() => setPowerBiModal("USDAAction")}
            >
              USDA Action Reports
            </button>

            <button
              className="tab"
              onClick={() => setPowerBiModal("AALAC")}
            >
              AAALAC Accreditation
            </button>
          </div>
        </div>

        <div className="reports-hero-count">
          <span>4</span>
          <p>Intelligence Tools</p>
        </div>
      </div>

      <div className="tabs-content">
        {activeTab === "complaints" && <Complaints />}
      </div>

      {powerBiModal && (
        <div className="powerbi-modal-overlay" onClick={closePowerBiModal}>
          <div className="powerbi-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="powerbi-modal-close"
              onClick={closePowerBiModal}
            >
              ×
            </button>

            <div className="powerbi-modal-body">
              {powerBiModal === "USDA" && <USDA modalOnly={true} />}
              {powerBiModal === "AALAC" && <AALAC modalOnly={true} />}
              {powerBiModal === "USDAAction" && <USDAAction modalOnly={true} />}
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <EmailFormModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          orgName="Due Diligence Request"
        />
      )}
    </div>
  );
};

export default TabsPage;